import React from 'react'
import FirebaseApp from '../FirebaseApp'
import { throwInline } from '../utils/throwErrorInline'
import { CloudListItemProduct, CloudRoom, CloudSharedList } from '../types/CloudSharedList'

type UseCloudListLoading = boolean
type UseCloudListError = any | null
type UseCloudListReturn = [UseCloudListLoading, UseCloudListError, CloudSharedList | null]

export const ListDoesntExistError: any = { get message() { return 'List doesn\'t exist' } }

async function fetchList(listId: string): Promise<CloudSharedList> {
  const db = FirebaseApp.firestore()

  const listData = await db.collection('sharedLists')
    .doc(listId)
    .get()
    .then(res => (res.data() ?? throwInline(ListDoesntExistError)) as CloudSharedList)

  const productData = await db.collection('sharedLists')
    .doc(listId)
    .collection('products')
    .get()
    .then(res => res.docs
      .map(it => it.data() as CloudListItemProduct)
      .sort((a, b) => a.order - b.order)
    )

  const rooms = await db.collection('sharedLists')
    .doc(listId)
    .collection('rooms')
    .get()
    .then(res =>
      res.docs
        .map(it => it.data() as CloudRoom)
        .sort((a, b) => a.order - b.order)
    )


  return {
    ...listData,
    configuredProducts: productData,
    rooms,
  }
}

export default function useCloudSharedList(listId: string): UseCloudListReturn {
  const [loading, setLoading] = React.useState(false)
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const [error, setError] = React.useState<any | null>(null)
  const [list, setList] = React.useState<CloudSharedList>({
    name: '', id: '', configuredProducts: [], rooms: []
  })

  React.useLayoutEffect(() => {
    setLoading(true)
    setError(null)

    fetchList(listId)
      .then(result => {
        setList(result)
      })
      .catch(e => {
        setError(e)
      })
      .finally(() => {
        setLoading(false)
      })

  }, [listId])

  return [loading, error, list]
}
